<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div v-if="formulaModal">
      <div class="row">
        <div class="col-12 mb-3 mt-1">
          <div class="generalTitleItemModal">
            <div>{{formulaModal.name}}</div>
            <div>{{formulaModal.condition}}</div>
          </div>
          <div class="form-group">
            <label class="generalLabel" for="valor">{{formulaModal.parameters}}:</label>
            <input type="text" class="form-control generalInput" id="valor"
              v-model.trim.lazy="v$.valor.$model">
            <div v-if="v$.valor.$dirty">
              <small class="form-text text-danger" v-if="v$.valor.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12">
            <button 
              class="btn btn-primary generalPrimaryButton float-right" 
              @click="guardar()"
              :disabled="v$.valor.$invalid">
                Guardar
            </button>
        </div>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators'

export default {
  name: "ModalCriteriaValor",
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    "id",
    "modalTitle",
    "class",
    "formulaModal",
  ],
  data() {
    return {
      classes: this.class,
      valor: '',
    };
  },
  components: {
    Modal,
  },
  validations() {
    return {
      valor: {
        required,
      },
    }
  },
  methods: {
    guardar(){
      this.$emit("guardarFormula", this.valor);
      this.onClose();
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
